import React from "react";
import { QrCode } from "lucide-react";

// Shared print-ready lanyard insert card. Exact badge size: 87mm x 118mm.
export default function LanyardCard({ displayName, jobTitle, photoUrl, qrPng, orgName, orgLogo, opts, testId }) {
  const accent = opts?.accent || "#4338CA";
  return (
    <div className="lanyard-card relative flex flex-col overflow-hidden bg-white"
      style={{ width: "87mm", height: "118mm", border: "1px dashed #cbd5e1" }} data-testid={testId}>
      {/* lanyard punch hole */}
      <div className="absolute left-1/2 top-[3mm] -translate-x-1/2 rounded-full border border-slate-300"
        style={{ height: "3mm", width: "12mm" }} />

      <div className="flex h-full flex-col items-center px-[6mm] pb-[6mm] pt-[9mm] text-center">
        {opts?.show_logo && (orgLogo || orgName) && (
          <div className="flex w-full items-center justify-center gap-[2.5mm]">
            {orgLogo && <img src={orgLogo} alt="logo" className="object-contain" style={{ height: "13mm", maxWidth: "26mm" }} />}
            {orgName && (
              <span className="font-head font-bold leading-tight"
                style={{ color: "#0F172A", fontSize: "4.6mm", maxWidth: "48mm" }}>{orgName}</span>
            )}
          </div>
        )}

        {opts?.show_photo && photoUrl && (
          <img src={photoUrl} alt={displayName} className="mt-[3mm] rounded-full object-cover"
            style={{ height: "20mm", width: "20mm", outline: `1mm solid ${accent}` }} />
        )}

        <div className="mt-[3.5mm] rounded-lg bg-white" style={{ border: `0.6mm solid ${accent}`, padding: "2mm" }}>
          {qrPng
            ? <img src={qrPng} alt="QR" style={{ height: "44mm", width: "44mm" }} />
            : <div className="flex items-center justify-center text-slate-300" style={{ height: "44mm", width: "44mm" }}><QrCode className="h-10 w-10" /></div>}
        </div>

        <p className="mt-[3mm] font-head font-bold" style={{ color: "#0F172A", fontSize: "6mm", lineHeight: 1.05 }}>{displayName}</p>
        {opts?.show_role && jobTitle && <p style={{ color: "#64748b", fontSize: "3.4mm", marginTop: "0.5mm" }}>{jobTitle}</p>}

        <p className="mt-auto w-full font-head font-extrabold uppercase"
          style={{ color: accent, fontSize: "6.2mm", lineHeight: 1.05, letterSpacing: "0.01em", wordBreak: "break-word" }}>
          {opts?.tagline}
        </p>
        <p className="mt-[1.5mm] w-full text-slate-400" style={{ fontSize: "2.6mm", letterSpacing: "0.04em" }}>
          Solution by Servantage
        </p>
      </div>
    </div>
  );
}
